var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.7496 4.75794C15.4246 4.43294 14.8996 4.43294 14.5746 4.75794L10.4996 8.82461L6.42461 4.74961C6.09961 4.42461 5.57461 4.42461 5.24961 4.74961C4.92461 5.07461 4.92461 5.59961 5.24961 5.92461L9.32461 9.99961L5.24961 14.0746C4.92461 14.3996 4.92461 14.9246 5.24961 15.2496C5.57461 15.5746 6.09961 15.5746 6.42461 15.2496L10.4996 11.1746L14.5746 15.2496C14.8996 15.5746 15.4246 15.5746 15.7496 15.2496C16.0746 14.9246 16.0746 14.3996 15.7496 14.0746L11.6746 9.99961L15.7496 5.92461C16.0663 5.60794 16.0663 5.07461 15.7496 4.75794Z",
    fill: "#BDBDCE"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.0c218a87ff943c24b358c18c26f573c2.svg";
export { ForwardRef as ReactComponent };